import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { UploaderBlock } from '../../abstract/UploaderBlock.js';
import { ActivityBlock } from '../../abstract/ActivityBlock.js';
import { UploadSource } from '../utils/UploadSource.js';
export class UrlSource extends UploaderBlock {
  constructor() {
    super(...arguments);
    _defineProperty(this, "couldBeCtxOwner", true);
    _defineProperty(this, "activityType", ActivityBlock.activities.URL);
    _defineProperty(this, "init$", _objectSpread(_objectSpread({}, this.init$), {}, {
      importDisabled: true,
      onUpload: e => {
        e.preventDefault();
        let url = this.ref.input['value'];
        this.addFileFromUrl(url, {
          source: UploadSource.URL_TAB
        });
        this.$['*currentActivity'] = ActivityBlock.activities.UPLOAD_LIST;
      },
      onCancel: () => {
        this.historyBack();
      },
      onInput: e => {
        let value = /** @type {HTMLInputElement} */e.target.value;
        this.set$({
          importDisabled: !value
        });
      }
    }));
  }
  initCallback() {
    super.initCallback();
    this.registerActivity(this.activityType, {
      onActivate: () => {
        this.ref.input['value'] = '';
        this.ref.input.focus();
      }
    });
  }
}
UrlSource.template = /* HTML */"\n  <lr-activity-header>\n    <button type=\"button\" class=\"mini-btn\" set=\"onclick: *historyBack\">\n      <lr-icon name=\"back\"></lr-icon>\n    </button>\n    <div>\n      <lr-icon name=\"url\"></lr-icon>\n      <span l10n=\"caption-from-url\"></span>\n    </div>\n    <button type=\"button\" class=\"mini-btn close-btn\" set=\"onclick: *closeModal\">\n      <lr-icon name=\"close\"></lr-icon>\n    </button>\n  </lr-activity-header>\n  <form class=\"content\">\n    <input placeholder=\"https://\" class=\"url-input\" type=\"text\" ref=\"input\" set=\"oninput: onInput\" />\n    <button\n      type=\"submit\"\n      class=\"url-upload-btn primary-btn\"\n      set=\"onclick: onUpload; @disabled: importDisabled\"\n    ></button>\n  </form>\n";